import React from 'react';
import { AuthProvider, AuthProviderProps, useAuth } from 'react-oidc-context';

type Props = {
  children: React.ReactNode;
};

const runtime = (typeof window !== 'undefined' && (window as any).RUNTIME_CONFIG) || {};
// Nur über runtime-config; kein process.env im Client, um Bundling von Env-Objekten zu verhindern
const issuer = runtime.REACT_APP_OIDC_ISSUER || '';
const clientId = runtime.REACT_APP_OIDC_CLIENT_ID || '';
const metadataUrl = runtime.REACT_APP_OIDC_METADATA_URL || '';

if (!issuer || !clientId) {
  // eslint-disable-next-line no-console
  console.warn('[OIDC] Missing required env vars. REACT_APP_OIDC_ISSUER and REACT_APP_OIDC_CLIENT_ID must be set.');
}

const oidcConfig: AuthProviderProps = {
  authority: issuer,
  client_id: clientId,
  redirect_uri: runtime.REACT_APP_OIDC_REDIRECT_URI || `${window.location.origin}/`,
  post_logout_redirect_uri: runtime.REACT_APP_OIDC_LOGOUT_REDIRECT_URI || `${window.location.origin}/`,
  scope: runtime.REACT_APP_OIDC_SCOPE || 'openid profile email',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  ...(metadataUrl
    ? { metadataUrl }
    : {}),
};

export default function OIDCProvider({ children }: Props) {
  const isEnvConfigured = Boolean(issuer && clientId);
  if (!isEnvConfigured) {
    // Render children without OIDC when envs are not set to avoid blocking navigation during setup
    return <>{children}</>;
  }
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}


